import React from 'react';
import { Box } from '@mui/material';
import AgentServicesTable from '../AgentServicesTable';
import { ServiceLockInfoButton } from '../AgentServicesTable/components/ServiceLockInfoButton';
import PanelCard from './PanelCard';

function CostsPanel() {
  return (
    <Box>
      <PanelCard
        title="Leistungen & Kosten"
        subtitle="Zugewiesene Leistungen mit Preisen"
        titleAction={<ServiceLockInfoButton />}
      >
        <AgentServicesTable />
      </PanelCard>
    </Box>
  );
}

export default CostsPanel;
